import i18n from './i18n.js';
import { normalizeText } from './utils.js';
import devicesData from '../data/devices.json';

/**
 * Compatibility checker for devices
 */
class CompatibilityChecker {
    constructor() {
        this.devices = devicesData || [];
    }

    /**
     * Searches devices by name
     * @param {string} query - Search query
     * @returns {Array<string>} Array of matching device names (max 10)
     */
    searchDevices(query) {
        if (!query || query.length < 1) return [];

        const normalizedQuery = normalizeText(query);
        const queryParts = normalizedQuery.split(' ').filter(part => part.length > 0);

        return this.devices
            .filter(device => {
                const normalizedDevice = normalizeText(device);
                return queryParts.every(part => normalizedDevice.includes(part));
            })
            .slice(0, 10);
    }

    /**
     * Checks if a device is compatible
     * @param {string} deviceName - Device name to check
     * @returns {Object} { compatible: boolean, device: string, message: string }
     */
    checkCompatibility(deviceName) {
        if (!deviceName) {
            return { compatible: false, device: null, message: null };
        }

        const normalizedDevice = normalizeText(deviceName);
        const device = this.devices.find(d => normalizeText(d) === normalizedDevice);

        if (!device) {
            return { 
                compatible: false, 
                device: null, 
                message: i18n.t('deviceNotFound') 
            };
        }

        const isNotCompatible = device.toLowerCase().includes('not compatible');
        
        return {
            compatible: !isNotCompatible,
            device: device,
            message: isNotCompatible 
                ? i18n.t('deviceNotCompatible')
                : i18n.t('deviceCompatible')
        };
    }
}

const compatibilityChecker = new CompatibilityChecker();
export default compatibilityChecker;

